import { OrderBaseView } from "../../../order/base";
import { Template } from "../../../../../../core/template/index";
import { FortumApp } from "../../../../../fortumApp";
import { View } from "../../../../../../core/view/index";
import { Order, OrderLike } from "../../../../../db/models/decontamination/order";
import { OrderItemLike, OrderItem } from "../../../../../db/models/decontamination/orderItem";
import { OrderItemDetailViewData } from "../../detail/index";
import ConfirmModal from "../../../../../../core/modals/confirm/index";
import { ClientAction } from "../../../../../synchronizer/index";

export default class OrderItemOverviewView extends View
{
    public template = Template.lazy('/app/views/decontamination/orderItem/tab/overview/index.html');
    public app: FortumApp;
    public data: DeconOrderOverviewTabViewData;

    constructor(data?: DeconOrderOverviewTabViewData) 
    {
        super(data);
    }

    public beforeRender(): PromiseLike<void>
    {
        return super.beforeRender().then(() =>
        {
            // TODO
            //this.data.cleansingTypeList = this.data.item.cleansing_types.map(o => o.type.name).join(', ');
        });
    }

    public afterRender(): PromiseLike<void>
    {        
        return super.afterRender();
    }
    
    private onSetCompletedButtonClick(e: MouseEvent, sender: HTMLButtonElement)
    {
        this.helpers.setButtonEnabled(sender, false);
        const done = () => {
            this.helpers.setButtonEnabled(sender, true);
        };
        const modal = new ConfirmModal({
            message: this.pgettext(
                'decontamination.message',
                'Are you sure you want to mark this order item as completed?'
            ),
            checkboxText: this.pgettext('decontamination.option', 'Return to record'),
            checked: true
        });
        modal.prompt().then((confirmed) => {
            if (!confirmed) {
                done();
                return;
            }
            return this.app.db.DeconOrderItem.where('id').equals(this.data.item.id).modify({state: 'completed', is_offline: 1}).then(() => {
                this.app.synchronizer.createMessageAndPull({
                    action: ClientAction.DECONTAMINATION.SET_ORDER_ITEM_COMPLETED,
                    data: {
                        order_item_id: this.data.item.id,
                    }
                }).then(() =>
                {
                    return this.app.refreshCurrentView({tab: 'overview'}).then(() =>
                    {
                        this.app.toasts.show(this.app.pgettext(
                            'decontamination.message',
                            'Successfully marked as completed!'
                        ));
                        
                        return this.onTrySetOrderAsCompleted(e, sender).then((redirected) =>
                        {
                            if (!redirected && modal.data.checked)
                            {
                                this.app.router.go(`#/order/${this.data.order.uuid}/detail`, {tab: 'items'});
                            }
                        });
                    })
                }, () =>
                {
                    done();
                });
            });
        });
    }

    private onTrySetOrderAsCompleted(e: MouseEvent, sender: HTMLButtonElement): PromiseLike<boolean>
    {
        return this.app.db.DeconOrderItem
            .where('order_id')
            .equals(this.data.order.id)
            .and(item => item.state != OrderItem.STATE_COMPLETED)
            .count((count) =>
        {
            // Can't find an item that isn't in state "completed"
            if (count == 0)
            {
                this.helpers.setButtonEnabled(sender, false);
                let modal = new ConfirmModal({
                    message: this.pgettext(
                        'decontamination.message',
                        'All items of this order are now completed. Would you like to complete the record as well?'
                    ),
                    checkboxText: this.pgettext('decontamination.option', 'Return to main menu'),
                    checked: true
                });
                
                return modal.prompt().then((confirmed) => {
                    if (!confirmed) {
                        return false;
                    }
                    return Order.complete(this.app, this.data.order.id).then(() => {
                        return this.app.refreshCurrentView({tab: 'overview'}).then(() =>
                        {
                            this.app.toasts.show(this.app.pgettext(
                                'decontamination.message',
                                'Successfully marked as completed!'
                            ));
    
                            if (modal.data.checked)
                            {
                                location.hash = '#/';
                                return true;
                            }
                            else
                            {
                                return false;
                            }
                        })
                    }, () =>
                    {
                        this.helpers.setButtonEnabled(sender, true);
                        return false;
                    });
                });
            }
        });
    }
}


export interface DeconOrderOverviewTabViewData extends OrderItemDetailViewData
{
    cleansingTypeList?: string;
}